module.exports = __webpack_public_path__ + "media/music/drumkit_5-dea8cbf5.mp3";